import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import "./map-vender.scss";
import { useParams, useNavigate } from "react-router-dom";
import React, { useEffect, useState, useRef } from "react";
import { getValue, setValue } from "@utils/lodash";
import Notfound from "@components/Not-Found-small";
import { toast } from "react-toastify";
import { Col, Row } from "reactstrap";
import {
  clientGetFunction,
  clientGetLocation,
} from "@services/location.service";
import Loader from "@components/common/Loader";
import { NavLink } from "react-router-dom";
import { QueryRequestHelper } from "@_common/query-request-helper";
import NoAccessPage from "@components/common/NoAccess";
import {
  addUserChildEntity,
  getChildEntityGroups,
  getEntityGroups,
  getUserChildEntities,
  deleteUserChildEntity,
} from "@services/entity-mapping.service";
import { adminGetSpecificUser } from "@services/users.service";
import SearchableDropdownSelect from "@_common/SearchableDropdown";
import { adminGetUsers } from "@services/users.service";
import { addSelfComplianceList } from "@services/self-compliance.service";
import SimpleReactValidator from "simple-react-validator";
import DeleteModal from "@_common/deleteModal";
import SearchHeader from "@components/common/SearchHeader";
import DashboardFilterForm from "@components/common/DashboardFilterForm";
import UserEntityTable from "./Table";
import PaginationPage from "@components/pagination/pagination";
import UserFilterForm from "./filter-form";
import MoreAdminSvgComponent from "../../../../assets/svg-components/left-menu/more-admin";

export default function UserEntityMapping(props: any) {
  let mainParams = useParams();
  let navigate = useNavigate();

  const simpleValidator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState(0);
  const [isFilterVisible, setFilterVisibility] = React.useState(true);

  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */
  const [submitLoading, setSubmitLoading] = useState(false);
  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length === 0 && props.permissionAPITriggered) {
      getUserInfo();
      getHeaderList(paramsObj, 0);
      getAssignedList();
    }
  }, [props.permissionAPITriggered]);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
      getHeaderList(paramsObj, 0);
      getAssignedList();
      // getEntityList();
      if (params.page_no) {
        setPage_no(parseInt(params.page_no));
      }
      if (params.limit) {
        setLimit(parseInt(params.limit));
      }
    }
  }, [window.location.href, props.permissionAPITriggered]);

  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */
  const [userInfo, setUserInfo] = useState({});
  const getUserInfo = async () => {
    try {
      let resp = await adminGetSpecificUser(getValue(mainParams, `id`, ""));
      if (resp) {
        setUserInfo(getValue(resp, `data`, {}));
      }
    } catch (error) {}
  };

  const [assignedList, setAssignedList] = useState([]);
  const [loading, setLoading] = useState(true);
  const getAssignedList = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    try {
      setLoading(true);
      let payload = {
        user_id: getValue(mainParams, `id`, ""),
        sort_by: "oldest",
        page_no: params.page_no ? parseInt(params.page_no) : 1,
        page_size: params.limit ? parseInt(params.limit) : limit,
      };
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getUserChildEntities(queryRequest);
      if (resp) {
        setAssignedList(getValue(resp, `data.entityPermissions`, []));
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const [headerList, setHeaderList] = useState([]);
  const [headerLoading, setHeaderLoading] = useState(true);
  const [levelObj, setLevelObj] = useState<any>({});
  const [paramsObj, setParamsObj] = useState<any>({});

  const getHeaderList = async (paramsObj: any, index: number) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      status: params.status ? params.status : "",
      sort_by: params.sort_by,
    };
    let queryRequest = QueryRequestHelper(payload);
    try {
      let resp = await getEntityGroups(queryRequest);
      if (resp) {
        setHeaderList(getValue(resp, `data.entityGroups`, []));
        var result: any = {};
        for (
          let i = 0;
          i < getValue(resp, `data.entityGroups.length`, 0);
          i++
        ) {
          result[
            `${getValue(resp, `data.entityGroups[${i}].group_level`, "")}`
          ] = { [getValue(resp, `data.entityGroups[${i}].id`, "")]: {} };
        }
        if (Object.keys(levelObj).length === 0) {
          for (let x in result) {
            let keys = Object.keys(result[x])[0];
            levelObj[keys] = {};
          }
        }
        // delete params[`checkpoint_id[]`];
        let list =
          Object.values(paramsObj).length > 0 ? Object.values(paramsObj) : [];
        if (getValue(list, `length`, 0) > 0) {
          list.map((item: any, _index: number) => {
            let findNextLevelInfo = getValue(
              resp,
              `data.entityGroups`,
              []
            ).filter(
              (ite: any) => ite.group_level === parseInt(item.split("_")[2]) + 1
            );
            if (_index === index)
              return getEntityList(
                getValue(findNextLevelInfo, `[${0}].id`, ""),
                item.split("_")[0],
                "",
                index
              );
          });
        } else {
          getEntityList(
            getValue(resp, `data.entityGroups[${0}].id`, ""),
            null,
            "",
            index
          );
        }
        setHeaderLoading(false);
      } else {
        setHeaderLoading(false);
      }
    } catch (error) {
      setHeaderLoading(false);
    }
  };

  const getEntityGroupsUponSelection = async (
    paramsObj: object,
    index: number
  ) => {
    let list =
      Object.values(paramsObj).length > 0 ? Object.values(paramsObj) : [];
    if (getValue(list, `length`, 0) > 0) {
      list.map((item: any, _index: number) => {
        let findNextLevelInfo = headerList.filter(
          (ite: any) => ite.group_level === parseInt(item.split("_")[2]) + 1
        );
        if (_index === index)
          return getEntityList(
            getValue(findNextLevelInfo, `[${0}].id`, ""),
            item.split("_")[0],
            "",
            index
          );
      });
    }
  };
  const [childEntityList, setChildEntityList] = useState<any>({});
  const [childEntityLoading, setChildEntityLoading] = useState(false);
  const getEntityList = async (
    id: string,
    entity_parent: any,
    search_text: string,
    index: number
  ) => {
    if (id) {
      let payload = {
        entity_group: id,
        entity_parent: entity_parent,
        limit: 10,
        search_text: search_text,
      };
      let queryRequest = QueryRequestHelper(payload);
      setChildEntityLoading(true);
      try {
        let resp = await getChildEntityGroups(queryRequest);
        if (resp) {
          levelObj[id] = getValue(resp, `data.entityMapping`, []).map(
            (item: any) => ({
              ...item,
              value: getValue(item, `entity_name`, ""),
              label: getValue(item, `entity_name`, ""),
            })
          );
          setLevelObj({ ...levelObj });
          setChildEntityLoading(false);
        } else {
          setChildEntityLoading(false);
        }
      } catch (error) {
        setChildEntityLoading(false);
      }
    } else {
      // toast.error("You have Reached Maximum Levels");
    }
  };
  const handleClickEntity = (
    entity_id: any,
    group_id: any,
    group_level: any,
    headerIndex: number
  ) => {
    //user selected level
    let userLevel = `${entity_id}_${group_id}_${group_level}`;
    let payload = { ...paramsObj };
    let selectedLevels =
      Object.values(payload).length > 0 ? Object.values(payload) : [];
    if (!selectedLevels.includes(userLevel)) {
      // appending child entity list that are presented in URL Params
      var result = Object.entries(childEntityList);
      var myNewArray: any =
        getValue(result, `length`, 0) > 0
          ? result.filter(function (item, index) {
              return index + 1 <= group_level;
            })
          : [];
      let obj: any = {};
      if (getValue(myNewArray, `length`, 0) > 0) {
        myNewArray.map((item: any) => {
          obj[item[0]] = item[1];
        });
      }
      setChildEntityList(obj);

      //deleting params if grater then current level selected by the user
      for (let i = group_level + 1; i < 10; i++) {
        delete paramsObj[`level${i}`];
      }

      // replacing url param if it have same group level / else we can add new one
      let checkIfAlreadyExist =
        Object.keys(payload).length > 0
          ? Object.keys(payload).includes(`level${group_level}`)
          : false;
      if (checkIfAlreadyExist) {
        delete paramsObj[`level${group_level}`];
        let obj = {
          ...paramsObj,
          [`level${group_level}`]: `${entity_id}_${group_id}_${group_level}`,
        };
        setParamsObj(obj);
        getEntityGroupsUponSelection(obj, headerIndex);
      } else {
        let obj = {
          ...paramsObj,
          [`level${group_level}`]: `${entity_id}_${group_id}_${group_level}`,
        };
        setParamsObj(obj);
        getEntityGroupsUponSelection(obj, headerIndex);
      }
    } else {
      // toast.error("Already selected");
    }
  };
  const handleChange = (
    val: string,
    entity_group: string,
    parent_level: any,
    index: number
  ) => {
    let entityID = getValue(paramsObj, `level${parseInt(parent_level) - 1}`, "")
      ? getValue(paramsObj, `level${parseInt(parent_level) - 1}`, "").split(
          "_"
        )[0]
      : null;

    if (!val) {
      getEntityList(entity_group, entityID, "", index);
      let length = Object.keys(paramsObj).length;
      for (let i = parent_level; i <= length; i++) {
        let id =
          paramsObj[`level${i + 1}`] &&
          paramsObj[`level${i + 1}`].split("_")[1];
        if (id) {
          levelObj[id] = {};
        }
        delete paramsObj[`level${i}`];
      }
      let obj = {
        ...paramsObj,
      };
      setParamsObj(obj);
      getHeaderList(obj, index);
    } else {
      getEntityList(entity_group, entityID, val, index);
    }
  };

  /* -----------------------------  Submit  ------------------------------ */

  const handleSubmit = async () => {
    const formValid = simpleValidator.current.allValid();
    if (!formValid) {
      simpleValidator.current.showMessages();
      forceUpdate(1);
    } else {
      const urlSearchParams = new URLSearchParams(window.location.search);
      let lengthOfLevels = Object.keys(paramsObj).length;
      let levelArr: any = [];
      for (let i = 0; i < lengthOfLevels; i++) {
        // levelObj[`level_${i + 1}`] = paramsObj[`level${i + 1}`]
        //   ? parseInt(paramsObj[`level${i + 1}`].split("_")[0])
        //   : "";
        levelArr.push({
          level: i + 1,
          value: paramsObj[`level${i + 1}`]
            ? parseInt(paramsObj[`level${i + 1}`].split("_")[0])
            : null,
        });
      }
      try {
        let payload = {
          user_id: getValue(mainParams, `id`, ""),
          userEgPermission: levelArr,
        };
        setSubmitLoading(true);
        let resp = await addUserChildEntity(payload);
        if (resp) {
          toast.success(getValue(resp, `message`, ""));
          setSubmitLoading(false);
          handleReset();
          getAssignedList();
        } else {
          setSubmitLoading(false);
        }
      } catch (error) {
        setSubmitLoading(false);
      }
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Onchange section                             */
  /* -------------------------------------------------------------------------- */
  const handleReset = () => {
    setParamsObj({});
  };

  const urlSearchParams = new URLSearchParams(window.location.search);
  const urlParams = Object.fromEntries(urlSearchParams.entries());

  let selectedIDs: any = urlSearchParams.getAll("checkpoint_id[]");

  /* -------------------------------------------------------------------------- */
  /*                                 Delete section                             */
  /* -------------------------------------------------------------------------- */

  const [deleteValue, setDeleteValue] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const handleDeleteEntity = (id: string, value: string) => {
    setDeleteValue(value);
    setDeleteId(id);
    handleDelete();
  };
  const [isDelete, setIsDelete] = useState(false);
  const handleDelete = () => {
    setIsDelete(!isDelete);
  };

  const handleDeleteFunction = async () => {
    try {
      let resp = await deleteUserChildEntity(deleteId);
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        handleDelete();
        getAssignedList();
      }
    } catch (error) {}
  };
  const reset = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      page_no: params.page_no,
      search_text: getValue(params, `search_text`, ""),
      limit: getValue(params, `limit`, ""),
    };
    setParamsObj({});
    setLevelObj({});
    getHeaderList({}, 0);
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    // getDataParamsObj({});
  };

  /* -------------------------------------------------------------------------- */
  /*                               Pagination section                           */
  /* -------------------------------------------------------------------------- */

  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(10);
  const [page_no, setPage_no] = useState(1);

  const handleChangePagination = (page_no: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload = {
      ...params,
      page_no: page_no,
    };
    let queryRequest = QueryRequestHelper(payload);

    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleChangeLimit = (limit: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      limit: limit,
      page_no: "1",
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleNavigateBack = () => {
    navigate(`/admin/users`);
  };
  return (
    <>
      <DashboardLayout
        permissions={getValue(props, `tabPermissionList`, [])}
        subTabPermissionList={getValue(props, `subTabPermissionList`, [])}
      >
        {!loading && !getValue(props, `products`, []).includes("SELFCOMP") ? (
          <NoAccessPage />
        ) : (
          <>
            <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between d-none">
              <div className="d-flex align-items-center">
                <div onClick={handleNavigateBack} className="cursor-pointer">
                  <img
                    src="/images/back-link.svg"
                    className="img-fluid add-filter-wrapper__upload-image"
                  />
                  &nbsp;&nbsp;&nbsp;
                </div>
                <h4 className="dashbaord-wrapper__header-title">
                  User Entity Mapping
                </h4>
                <p className="text_entity">
                  {" "}
                  ( {getValue(userInfo, `first_name`, "")}{" "}
                  {getValue(userInfo, `last_name`, "")} )
                </p>
              </div>
            </div>

            <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <div
                  onClick={handleNavigateBack}
                  className="cursor-pointer me-2"
                >
                  <img
                    src="/images/back-link.svg"
                    className="img-fluid add-filter-wrapper__upload-image"
                  />
                </div>

                <div className="header-parent-icon-holder">
                  <MoreAdminSvgComponent />
                </div>

                <div className="title-wrapper">
                  <h6 className="dashbaord-wrapper__header-parent-title">
                    Users
                  </h6>
                  <h4 className="dashbaord-wrapper__header-title">
                    User Entity Mapping
                    <span className="text_entity">
                      ( {getValue(userInfo, `first_name`, "")}{" "}
                      {getValue(userInfo, `last_name`, "")} )
                    </span>
                  </h4>
                </div>
              </div>

              <div className="d-flex align-items-center"></div>
            </div>

            <div className="main-page-layout-wrapper">
              <div className="admin-wrapper position-relative">
                {/* <div className="admin-wrapper position-relative">
                <SearchHeader
                  smartFilter={true}
                  setFilterFormVisibility={() => {
                    setFilterVisibility(!isFilterVisible);
                  }}
                  add={"false"}
                  search={"false"}
                  isFilterVisible={isFilterVisible}
                />
              </div> */}
                <div className="user-entity-mapping-filter-card">
                  {isFilterVisible && (
                    <UserFilterForm
                      setFilterFormVisibility={() => {
                        setFilterVisibility(!isFilterVisible);
                      }}
                      reset={reset}
                      handleSubmitSmartFilter={handleSubmit}
                      //-----> Entity Mapping Filter
                      headerList={headerList}
                      headerLoading={headerLoading}
                      levelObj={levelObj}
                      childEntityLoading={childEntityLoading}
                      handleClickEntity={handleClickEntity}
                      urlParams={paramsObj}
                      handleChangeEntity={handleChange}
                      submitText={"Add"}
                      permissions={getValue(props, `permissions`, [])}
                    />
                  )}
                </div>
              </div>
              {loading ? (
                <Loader />
              ) : getValue(assignedList, `length`, 0) > 0 ? (
                <div className="admin-wrapper position-relative user-entity-mapping-table-wrap">
                  <UserEntityTable
                    headerList={headerList}
                    assignedList={assignedList}
                    handleDeleteEntity={handleDeleteEntity}
                    permissions={getValue(props, `permissions`, [])}
                  />
                </div>
              ) : (
                <Notfound />
              )}

              <div className="footer-wrapper d-flex justify-content-between">
                {assignedList.length > 0 && (
                  <img
                    src="/images/building-illustration.svg"
                    className="img-fluid"
                  />
                )}
                {totalCount > 10 ? (
                  <PaginationPage
                    totalCount={totalCount}
                    limit={limit}
                    pageNumber={page_no}
                    handleChangePagination={handleChangePagination}
                    handleChangeLimit={handleChangeLimit}
                  />
                ) : (
                  <p className="show-rows-count mt-3 d-flex">
                    Total Count:&nbsp;&nbsp;{" "}
                    <p style={{ color: "rgb(13, 110, 253)" }}>{totalCount}</p>
                  </p>
                )}
              </div>
            </div>
          </>
        )}
      </DashboardLayout>
      <DeleteModal
        isOpen={isDelete}
        handleModal={handleDelete}
        handleSubmit={handleDeleteFunction}
        deleteValue={deleteValue}
      />
    </>
  );
}
